import type { KnowledgeArticle } from "../types"

export const watKostMaatwerkAi: KnowledgeArticle = {
  id: "insight:wat-kost-maatwerk-ai",
  pageType: "knowledge-article",
  slug: { nl: "wat-kost-maatwerk-ai" },
  title: {
    nl: "Wat Kost een AI Agent of Maatwerk AI? | Budgetten en doorlopende kosten",
    en: "What Does Custom AI Cost? | Realistic budgets and running costs",
  },
  description: {
    nl: "Wat kost een AI agent of maatwerk AI echt? De factoren die de prijs bepalen, welke doorlopende kosten bedrijven over het hoofd zien en hoe je budget verstandig verdeelt.",
    en: "What does custom AI really cost? The factors that determine price, the running costs companies overlook, and how to spend your budget wisely.",
  },
  h1: {
    nl: "Wat kost een AI agent of maatwerk AI?",
    en: "Wat kost een AI agent of maatwerk AI?",
  },
  published: "2026-08-26",
  modified: "2026-10-29",
  author: "Camiel Schmeitz",
  sections: [
    {
      type: "paragraph",
      text: "De eerlijkheid vooraf: er bestaat geen vast prijslijstje voor maatwerk AI of voor een AI agent, en wie wel één noemt zonder je proces te kennen, verkoopt je iets anders dan maatwerk. Wat wél kan: de factoren benoemen die de investering bepalen, zodat je weet waar je budget naartoe gaat.",
    },
    {
      type: "heading",
      text: "Wat kost een AI-agent?",
    },
    {
      type: "paragraph",
      text: "Een AI-agent is een van de vormen van maatwerk AI, dus dezelfde factoren bepalen de prijs. Een agent die alleen vragen beantwoordt uit een kennisbank is aanzienlijk eenvoudiger en goedkoper dan een agent die zelfstandig acties uitvoert in meerdere systemen en daarbij goedkeurstappen, logging en monitoring nodig heeft. Hoe meer de agent mag doen, hoe meer er ontworpen, getest en bewaakt moet worden.",
    },
    {
      type: "heading",
      text: "De vier kostenbepalende factoren",
    },
    {
      type: "list",
      items: [
        "Complexiteit van integratie: hoeveel systemen moet de oplossing aanraken, en hoe schoon zijn die interfaces?",
        "Staat van de data: gestructureerd en beschikbaar versus verspreid, rommelig of ontoegankelijk — dataopschoning is vaak de grootste post.",
        "Kwaliteitseisen: hoe erg is een fout antwoord of actie? Hogere inzet vraagt meer evaluatie, controles en goedkeurstappen.",
        "Schaal en beschikbaarheid: een intern hulpmiddel voor tien mensen bouwt sneller dan een klantgericht systeem dat continu moet draaien.",
      ],
    },
    {
      type: "heading",
      text: "Doorlopende kosten worden vaak vergeten",
    },
    {
      type: "paragraph",
      text: "Naast de bouw zijn er structurele kosten: modelgebruik per request, hosting, monitoring en onderhoud van de kennisbank. Modellen en hun prijzen veranderen bovendien snel; een goede architectuur houdt het wisselen van modellen mogelijk zodat je niet vastzit aan één leverancier of tarief.",
    },
    {
      type: "heading",
      text: "Verdeel je budget in fasen",
    },
    {
      type: "paragraph",
      text: "Ons advies is vrijwel altijd hetzelfde: begin met een betaalbare verkenning waarin haalbaarheid en waarde bewezen worden, gebruik dat als beslismoment voor de productie-bouw, en reserveer budget voor beheer na livegang. Zo koop je informatie vóórdat je het grote bedrag uitgeeft — en soms is het advies zelfs om niet te bouwen, wat je dan net zo goed geld bespaart.",
    },
    {
      type: "callout",
      title: "Eerlijke indicatie",
      text: "Zonder jouw proces te kennen kunnen we geen bedrag noemen — en wantrouw partijen die dat wel doen. Wat we wél direct kunnen: in een gratis kennismaking inschatten of je idee haalbaar is en welke fasering passend is.",
    },
    {
      type: "heading",
      text: "Waarmee je geld kunt besparen",
    },
    {
      type: "list",
      items: [
        "Begin smaller dan je eindbeeld: één proces, één duidelijke winst.",
        "Hergebruik bestaande infrastructuur waar het kan in plaats van alles nieuw te bouwen.",
        "Meet vanaf dag één: zonder baselinemeting kun je nooit aantonen — of inkrimpen — wat het oplevert.",
      ],
    },
  ],
  relatedServiceIds: ["ai-agents", "ai-development", "ai-consultancy"],
  relatedCaseIds: ["de-limburger"],
}
